import CloseIcon from "@mui/icons-material/Close";
import { Grid, IconButton } from "@mui/material";
import React from "react";

import { Lead } from "../../Models/Lead";

interface Props {
  isSessionComplete: boolean;
  lead: Lead;
  handleClose: () => void;
}

const TabLabel: React.FC<Props> = ({ isSessionComplete, lead, handleClose }: Props) => {
  const title =
    `${lead.firstName || ""}${(lead.firstName && lead.lastName && " ") || ""}${lead.lastName || ""}` ||
    lead.phoneNumber ||
    lead.email ||
    "unknown";
  return (
    <Grid container alignItems="center">
      <Grid item xs>
        {title}
      </Grid>
      {isSessionComplete && (
        <Grid item>
          <IconButton sx={{ padding: "unset" }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default TabLabel;
